import { render, staticRenderFns } from "./TireDialogTabsExpansionDialog.vue?vue&type=template&id=f5270b60&"
import script from "./TireDialogTabsExpansionDialog.vue?vue&type=script&lang=js&"
export * from "./TireDialogTabsExpansionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports